import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { useTranslation } from 'react-i18next';
import { INVOICES_ORDER_DETAILS, UPDATE_ORDER } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import ProductCal from '../layout/ProductCal';
import Alert from '../../../feature/Alert';
import { useNavigate, useParams } from 'react-router-dom';
import SelectCustomer from '../layout/SelectCustomer';


export default function EditInvoice() {

     const { id } = useParams();
     const [customerId, setCustomerId] = useState('');
     const [state_id, setStateId] = useState('');
     const [customerDetails, setCustomerDetails] = useState({});
     const [errors, setErrors] = useState({});
     const [invoice_order, setInvoiceOrder] = useState({});
     const [customer, setCustomer] = useState({});
     const [products, setProducts] = useState([]);
     const [updatedProducts, setUpdatedProducts] = useState([]);
     const [notes, setNotes] = useState({});
     const { t } = useTranslation();
     const navigate = useNavigate();

     const [orderDetails, setOrderDetails] = useState({prefix: '',  invoice_number: '', invoice_date: '', due_date: '' });

     useEffect(() => {       
          getOrderDetails();
     }, [])

     useEffect(() => {     
          setNotes({ terms_conditions: invoice_order.terms_conditions, private_notes: invoice_order.private_notes });
          setOrderDetails({prefix: invoice_order.prefix, invoice_number: invoice_order.invoice_number, invoice_date: invoice_order.invoice_date, due_date: invoice_order.due_date !== null ? invoice_order.due_date : '' })
     }, [customerDetails, invoice_order]);

     useEffect(() => {
          if (products.length > 0) {
               const data = [];
               products.map((row, index) => {
                    data.push(
                         {
                              selectedProduct: { label: row.product_name, value: row.product_id },
                              desc: row.description,
                              sac: row.sac,
                              selectedUnit: { label: row.unit_name, value: row.unit_id },
                              quantity: row.quantity,
                              price: row.price,
                              discount: row.discount,
                              discountType: row.discountType,
                              tax: row.tax,
                              total: row.net_amount,
                              stock: row.stock,
                              taxableAmount: row.taxable_amount,
                              discountAmount: row.discount_amount,
                              taxAmount: row.tax_amount
                         }
                    )
               })
               setUpdatedProducts(data);
          }

     }, [products]);

     const getOrderDetails = async (e) => {
          const res = await httpClient.post(INVOICES_ORDER_DETAILS, { invoice_id: id });
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    setCustomerId(result.data.invoice_order.customer_id);
                    setInvoiceOrder(result.data.invoice_order);
                    setProducts(result.data.details);
                    setCustomerDetails(result.data.customer);
               }
          }
     }

     const handelSubmit = (products, commanData, totals, txnType) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = orderDetails;
                    p['customer_id'] = customerId;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;
                    p['id'] = id;
                    saveOrder(p);
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(UPDATE_ORDER, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status == 1) {
                    Alert.success(result.message);
                    navigate('/root/invoices');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (customerId === '') {
               Alert.error('Select Customer');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...orderDetails };
          order[fieldName] = value;
          setOrderDetails(order);
     };

     const remitCustomer = (data) => {
          setCustomerId(data.customer_id);
          setStateId(data.state_id);
          setCustomer(data.customer);
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="edit_invoice" subTitle="invoices" subTitleLink="root/invoices" />
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectCustomer remitCustomer={remitCustomer} customerId={customerId} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-4 '>
                                        <label htmlFor='prefix'>{t('invoice_number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{width:"80px"}}>
                                             <input id='prefix' value={orderDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={orderDetails.invoice_number} type='text' name='invoice_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='invoice_date'>{t('invoice_date')}</label>
                                        <input id='invoice_date' value={orderDetails.invoice_date} type='date' name='invoice_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_date', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='due_date'>{t('due_date')}</label>
                                        <input id='due_date' value={orderDetails.due_date} type='date' name='due_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('due_date', e)} />
                                   </div>
                              </div>
                              <ProductCal title="invoice_details" onSubmit={handelSubmit} customer={customer} products={updatedProducts} notes={notes} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
